// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2XF8q","cell":"ColumnAccessor_cell__2EnKU","firstCellAccent":"ColumnAccessor_firstCellAccent__bSMuA"};